import { render, staticRenderFns } from "./NewFacility.vue?vue&type=template&id=6694f5dc"
import script from "./NewFacility.vue?vue&type=script&lang=js"
export * from "./NewFacility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports